import {
  Box,
  List,
  ListItem,
  Link as MuiLink,
  Typography,
} from "@mui/material";
import { FC } from "react";
import { useFooterNav } from "./hooks";
import LogoIcon from "../../assets/icons/Logo.svg";
import TwitterIcon from "../../assets/icons/Twitter.svg";
import FacebookIcon from "../../assets/icons/Facebook.svg";
import LinkedinIcon from "../../assets/icons/Linkedin.svg";
import ChromeExtensionIcon from "../../assets/icons/ChromeExtension.svg";
import { Container } from "../Container";
import styles from "./styles.module.scss";
import { ROUTES, EXTERNAL_ROUTES } from "../../libs/routing";

export const Footer: FC = () => {
  const { config } = useFooterNav();
  return (
    <Box component="footer" className={styles.footer}>
      <Container>
        <Box className={styles.head}>
          <a href="/" className={styles.logo}>
            <img src={LogoIcon} />
          </a>
          <Box className={styles.social}>
            <MuiLink
              href={EXTERNAL_ROUTES.SOCIAL.TWITTER}
              className={styles.socialLink}
            >
              <img src={TwitterIcon} />
            </MuiLink>
            <MuiLink
              href={EXTERNAL_ROUTES.SOCIAL.FACEBOOK}
              className={styles.socialLink}
            >
              <img src={FacebookIcon} />
            </MuiLink>
            <MuiLink
              href={EXTERNAL_ROUTES.SOCIAL.LINKEDIN}
              className={styles.socialLink}
            >
              <img src={LinkedinIcon} />
            </MuiLink>
          </Box>
        </Box>
        <Box className={styles.nav}>
          {config.map((item) => {
            return (
              <Box className={styles.navItem} key={item.label}>
                <Typography className={styles.navLabel}>
                  {item.label}
                </Typography>
                <List className={styles.navList}>
                  {item.children.map((inner, index) => {
                    return (
                      <ListItem
                        key={`${item.label + index}`}
                        className={styles.navListItem}
                      >
                        <a
                          href={inner.link || "#"}
                          className={styles.navLink}
                          {...(Boolean(inner?.target) && {
                            target: inner.target,
                          })}
                        >
                          {inner.label}
                        </a>
                      </ListItem>
                    );
                  })}
                </List>
              </Box>
            );
          })}
          <Box className={styles.navItem}>
            <Typography className={styles.navLabel}>
              {"Unlimited prospecting on Linkedin"}
            </Typography>
            <Typography className={styles.navDesc}>
              {
                "Collect verified emails and direct dials for the decision makers you need to reach."
              }
            </Typography>
            <MuiLink
              href={EXTERNAL_ROUTES.EXTENSION_MARKET}
              target="_blank"
              className={styles.navIcoLink}
            >
              <img src={ChromeExtensionIcon} />
            </MuiLink>
          </Box>
        </Box>
        <Box className={styles.bottomInfo}>
          <Typography variant="body2" className={styles.disclaimer}>
            {`@${new Date().getFullYear()}. Powerlead. All rights reserved.`}
          </Typography>
          <Box className={styles.bottomInfoLinks}>
            <MuiLink
              href={ROUTES.PRIVACY_POLICY}
              className={styles.bottomInfoLink}
            >
              {"Privacy Policy"}
            </MuiLink>
            <MuiLink
              href={ROUTES.TERMS_OF_USE}
              className={styles.bottomInfoLink}
            >
              {"Terms"}
            </MuiLink>
            <MuiLink href="#" className={styles.bottomInfoLink}>
              {"Cookies Policy"}
            </MuiLink>
            <MuiLink href={ROUTES.OPT_OUT} className={styles.bottomInfoLink}>
              {"Don’t sell my info "}
            </MuiLink>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};
